<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-sub-title
                    text="Reporte de implementación de Bitacorapp en clientes"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-alert show variant="info">
                    Total registros operativos:
                    {{ totalRegs.toLocaleString() }} distribuidos así:
                </b-alert>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-data-table :items="implementation" :fields="fields">
                    <template slot="index" slot-scope="{row}">
                        {{ row + 1 }}
                    </template>
                    <template slot="created_at" slot-scope="{ item }">
                        {{ item.created_at | datetime }}
                    </template>
                    <template slot="person_entries_count" slot-scope="{ item }">
                        {{ item.person_entries_count.toLocaleString() }}
                    </template>
                    <template
                        slot="vehicle_entries_count"
                        slot-scope="{ item }"
                    >
                        {{ item.vehicle_entries_count.toLocaleString() }}
                    </template>
                    <template slot="notebooks_count" slot-scope="{ item }">
                        {{ item.notebooks_count.toLocaleString() }}
                    </template>
                    <template slot="mails_count" slot-scope="{ item }">
                        {{ item.mails_count.toLocaleString() }}
                    </template>
                    <template
                        slot="round_instances_count"
                        slot-scope="{ item }"
                    >
                        {{ item.round_instances_count.toLocaleString() }}
                    </template>
                    <template
                        slot="contact_reports_count"
                        slot-scope="{ item }"
                    >
                        {{ item.contact_reports_count.toLocaleString() }}
                    </template>
                    <template
                        slot="body_guard_services_count"
                        slot-scope="{ item }"
                    >
                        {{ item.body_guard_services_count.toLocaleString() }}
                    </template>
                    <template slot="venues_count" slot-scope="{ item }">
                        {{ item.venues_count.toLocaleString() }}
                    </template>
                    <template slot="structures_count" slot-scope="{ item }">
                        {{ item.structures_count.toLocaleString() }}
                    </template>
                    <template
                        slot="safety_recommendations_count"
                        slot-scope="{ item }"
                    >
                        {{ item.safety_recommendations_count.toLocaleString() }}
                    </template>
                    <template slot="vehicle_states_count" slot-scope="{ item }">
                        {{ item.vehicle_states_count.toLocaleString() }}
                    </template>
                    <template slot="totalRegs" slot-scope="{ item }">
                        {{ item.totalRegs.toLocaleString() }}
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        implementation: [],
        totalRegs: 0,
        fields,
    }),
    computed: {
        //
    },
    methods: {
        async loadClientsImplementation() {
            const { data } = await repo.get(
                'reporting/company/adoption/clients-implementation'
            )
            this.implementation = data
                .map(item => ({
                    ...item,
                    totalRegs:
                        item.person_entries_count +
                        item.vehicle_entries_count +
                        item.notebooks_count +
                        item.mails_count +
                        item.round_instances_count +
                        item.contact_reports_count +
                        item.body_guard_services_count +
                        item.venues_count +
                        item.structures_count +
                        item.safety_recommendations_count +
                        item.vehicle_states_count,
                }))
                .sort((a, b) => b.totalRegs - a.totalRegs)

            this.totalRegs = this.implementation.reduce(
                (carry, item) => carry + item.totalRegs,
                0
            )
        },
    },
    mounted() {
        this.loadClientsImplementation()
    },
}
const fields = [
    {
        key: 'index',
        label: '#',
    },
    {
        key: 'name',
        label: 'Cliente',
    },
    {
        key: 'created_at',
        label: 'Registro',
    },
    {
        key: 'venues_count',
        label: 'Sedes',
    },
    {
        key: 'structures_count',
        label: 'Estructuras',
    },
    {
        key: 'person_entries_count',
        label: 'Ingresos peatonales',
    },
    {
        key: 'vehicle_entries_count',
        label: 'Ingresos vehiculares',
    },
    {
        key: 'notebooks_count',
        label: 'Minutas',
    },
    {
        key: 'mails_count',
        label: 'Correspondencia recibida',
    },
    {
        key: 'contact_reports_count',
        label: 'Reuniones',
    },
    {
        key: 'round_instances_count',
        label: 'Rondas',
    },
    {
        key: 'safety_recommendations_count',
        label: 'Recomendaciones de seguridad',
    },
    {
        key: 'body_guard_services_count',
        label: 'Servicios de escolta',
    },
    {
        key: 'vehicle_states_count',
        label: 'Minutas vehiculares',
    },
    {
        key: 'totalRegs',
        label: 'Total',
    },
]
</script>
